import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";

function CustomersTableData({ data, onEdit, onDelete }) {
  const columns = [
    { Header: "Card", accessor: "card_number", align: "left" },
    { Header: "Name", accessor: "owner_name", align: "left" },
    { Header: "Phone", accessor: "owner_phone_number", align: "left" },
    { Header: "Patient No", accessor: "owner_patient_number", align: "left" },
    { Header: "Email", accessor: "owner_email", align: "left" },
    { Header: "Available Points", accessor: "available_points", align: "right" },
    { Header: "Pending Points", accessor: "pending_points", align: "right" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((c) => ({
    card_number: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {c.card_number || "—"}
      </MDTypography>
    ),
    owner_name: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {c.owner_name || "—"}
      </MDTypography>
    ),
    owner_phone_number: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {c.owner_phone_number || "—"}
      </MDTypography>
    ),
    owner_patient_number: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {c.owner_patient_number || "—"}
      </MDTypography>
    ),
    owner_email: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {c.owner_email || "—"}
      </MDTypography>
    ),
    available_points: (
      <MDTypography variant="caption" fontWeight="medium">
        {Number(c.available_points || 0).toLocaleString()}
      </MDTypography>
    ),
    pending_points: (
      <MDTypography variant="caption" fontWeight="regular" color="warning">
        {Number(c.pending_points || 0).toLocaleString()}
      </MDTypography>
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(c)}>
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(c)}>
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
    />
  );
}

CustomersTableData.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CustomersTableData;
